import React, { FC, useCallback, useContext, useMemo } from 'react';
import AnimatedCard from '../../../AnimatedCard';
import styles from './index.module.scss';
import { getSVG } from '@/components/Common/styles/mixins';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';

const NolCardCashback: FC = () => {
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/v9/${path}`), []);
  const store = useContext(NolPromotionStoreCtx);

  const nolCouponCardProps = useMemo(() => {
    return {
      type: 'gray' as const,
      supTitle: <div className={styles.cardSupTitle}>이벤트 2</div>,
      title: (
        <div className={styles.cardTitle}>
          NOL에서 첫 결제 시
          <br />
          <span className={styles.blue}>2만원 캐시백</span>
        </div>
      ),
      image: (
        <img
          className={styles.nolCouponImage}
          src={getResourcePath('v28_nol_card_cashback.png')}
          alt={'NOL에서 첫 결제 시 2만원 캐시백'}
        />
      ),

      descriptionTitle: (
        <div className={styles.descriptionTitle}>
          NOL 카드 페이에 등록된 NOL 카드로
          <br />
          NOL에서 단건 2만 1천원 이상 첫 결제 시
        </div>
      ),
      descriptions: [
        {
          text: <>이벤트 기간 : {store.eventPeriod}</>,
          normal: true,
        },
        {
          text: (
            <>
              혜택 : 2만원 캐시백
              <br />: 이벤트 기간 직전 6개월 간(2025.09.10 ~ 2026.03.09) NOL 카드 결제 이력이 없는 NOL 카드 보유 회원이
              NOL 카드 페이에 등록된 NOL 카드로 이벤트 기간 동안 NOL에서 단건 2.1만원 이상 첫 결제 시 제공
            </>
          ),
          normal: true,
        },
        {
          text: (
            <>
              NOL 카드 보유 회원 대상에 한해 혜택 적용
              <br />
              (본인 회원 기준, 1회 제공)
            </>
          ),
          normal: true,
        },
        {
          text: <>조건 충족 시 26년 6월 말일 경, 본인 명의 현대카드 결제 계좌로 지급</>,
          normal: true,
        },
        {
          text: <>무이자 할부 결제 시 혜택 제공 불가</>,
          normal: true,
        },
        {
          text: (
            <>
              NOL 카드 페이 및 NOL 인터파크페이가 아닌 간편결제 서비스(카카오페이, 네이버페이, PAYCO 등)로 결제 시 혜택
              제공 불가
            </>
          ),
          normal: true,
        },
        {
          text: (
            <>
              항공권 결제 시에는 NOL 카드 페이 미 이용 시에도 혜택 적용됨
              <br />
              (단, 에어서울, 이스타 항공 국내선 항공권 결제 시에는 캐시백 제공 불가)
            </>
          ),
          normal: true,
        },
        {
          text: (
            <>
              NOL 카드 첫 결제 혜택은 NOL/NOL 인터파크(NOL 인터파크투어/NOL 티켓)/트리플 내 본인 회원 기준 1회 제공되며,
              기간 내 첫 결제처를 기준으로 혜택 적용 됨
              <br />- NOL 외 NOL 인터파크(NOL 인터파크투어/NOL 티켓)/트리플에서 진행하는 NOL 카드 첫 결제 헤택(첫 결제
              캐시백, 첫 결제 쿠폰 등)과 중복 제공 불가
            </>
          ),
          normal: true,
        },
        {
          text: <>다른 NOL 카드 혜택 (NOL 카드 캐시백, NOL 카드 할인 쿠폰 등)과 중복 제공 되지 않음</>,
          normal: true,
        },
        {
          text: (
            <>
              현대카드의 다른 이용 유도 프로모션에 참여했거나 혜택(첫 결제, 포인트, 할인 쿠폰 등)을 받은 경우, 조건을
              충족하더라도 혜택 중복 적용 불가
            </>
          ),
          normal: true,
        },
        {
          text: <>이벤트 유의사항 및 상세 내용은 자세히 보기 참조</>,
          bold: false,
          normal: true,
        },
      ],
    };
  }, []);

  return (
    <AnimatedCard
      className={styles.nolCouponCardContainer}
      {...nolCouponCardProps}
      onDetailClick={() => (store.isCashbackBottomSheetOpen = true)}
      logData={{
        object: '자세히 보기',
        objectType: 'Btn',
        objectContainer: 'NOL에서 지금 받는 NOL 이벤트 혜택',
        motherPageVersion: store.version,
        motherPageSectionType: '혜택',
        motherPageSectionName: 'NOL에서 첫 결제 시 2만원 캐시백',
        deepLinkUri: '',
      }}
    />
  );
};

export default observer(NolCardCashback);
